import { MARK_COOKIE_BANNER_SEEN } from '../actionTypes';

const initialState = {
  cookieBannerSeen: false,
  // appInstallationId: uuid(),
};

export function appReducer(state = initialState, action) {
  switch (action.type) {
    case MARK_COOKIE_BANNER_SEEN:
      return {
        ...state,
        cookieBannerSeen: true,
      };
    default:
      return state;
  }
}
